<template>
  <div id="main">
    <div class="main_title">
      <div class="line"></div>
      <div style="font-family:SimHei;font-size:22px;">
        产品中心>>>
        <router-link to="/">
          <img class="back_to_index" src="../../assets/images/back_to_index.png" alt />
        </router-link>
      </div>

      <div style="font-family:SimHei;font-size:16px;padding:20px 0 0 0;">
        <a @click="update_procudt(33)">最新推出</a>>
        <!-- style="color:#3f33c0;" -->
        <!-- <router-link>军品系列</router-link>> -->
        <a @click="update_procudt(9)">交直流标准源系列</a>>
        <a @click="update_procudt(16)">铁路计量专用系列</a>>
        <a @click="update_procudt(18)">多功能标准表系列</a>>
        <a @click="update_procudt(21)">交直流电测仪表校验台系列</a>>
        <a @click="update_procudt(25)">交直流检定装置系列</a>>
        <a @click="update_procudt(30)">多功能现场校验仪系列</a>
      </div>
    </div>

    <!-- 点击切换 -->
    <div class="pageDiv">
      <div
        class="upDiv"
        v-for="(item,index) in data_info.list"
        :key="index"
        @click="update_procudt(item.id)"
      >
        <p>{{item.name}}</p>
        <img :src="item.image" />
      </div>
    </div>

    <div style="width:100%;background-color:#e8e8e8;height:30px;position: absolute;left:0;"></div>

    <!-- 产品介绍 -->
    <div class="main_inner">
      <div class="product_info">
        <div class="product_img">
          <img class="img" :src="data_info.info.image" />
        </div>
        <div class="product_item_info">
          <div class="product_item_info_title">{{data_info.info.name}}</div>
          <div v-if="data_info.info.description" v-html="data_info.info.description"></div>
          <div v-else>暂无详细数据</div>
        </div>
      </div>
    </div>

    <!-- 主要功能特点 -->
    <div class="special">
      <div class="tip_title">
        <img src="../../assets/images/tips.png" alt />
        <span>主要功能</span>
      </div>

      <div v-if="data_info.info.gn" v-html="data_info.info.gn"></div>
      <div v-else>暂无详细数据</div>
    </div>

    <!-- 主要技术指标 -->
    <div class="main_skill">
      <div class="tip_title">
        <img src="../../assets/images/tips.png" alt />
        <span>技术指标</span>
      </div>

      <div v-if="data_info.info.jszb" v-html="data_info.info.jszb"></div>
      <div v-else>暂无详细数据</div>
    </div>

    <!-- 其他 -->
    <div class="other">
      <div class="tip_title">
        <img src="../../assets/images/tips.png" alt />
        <span>其他</span>
      </div>

      <div v-if="data_info.info.others" v-html="data_info.info.others"></div>
      <div v-else>暂无详细数据</div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      data_info: "", //全部信息
    };
  },
  methods: {
    update_procudt: function (id) {
      this.$fetch("Product/detail", { id: id }).then((res) => {
        if (res.code == 1) {
          // console.log(res);
          this.data_info = res.data;
        } else {
          alert("请求出错，请稍后再试");
        }
      });
    },
  },
  created: function () {
    if (this.$route.query.id) {
      this.$fetch("Product/detail", { id: this.$route.query.id }).then(
        (res) => {
          if (res.code == 1) {
            // console.log(res);
            this.data_info = res.data;
          } else {
            alert("请求出错，请稍后再试");
          }
        }
      );
    }
  },
};
</script>
<style scoped>
a {
  cursor: pointer;
}
.tip_title {
  width: 235px;
  height: 72px;
  text-align: center;
  font-size: 26px;
  position: relative;
  margin: 40px 0px 20px 0;
}
.tip_title img {
  width: 100%;
  height: 100%;
}
.tip_title span {
  position: absolute;
  left: 0;
  top: 17px;
  color: #fff;
  text-align: center;
  display: inline-block;
  width: 100%;
}
.main_title {
  width: 100%;
  height: 24px;
  margin: 40px 0 60px 0;
  font-size: 20px;
}

.line {
  background-color: #2569e6;
  width: 3px;
  height: 100%;
  float: left;
  margin-right: 20px;
}
.main_inner {
  width: 100%;
  margin-top: 110px;
}
.product_info {
  margin-bottom: 40px;
  height: 370px;
}
.main_inner .product_img {
  width: 500px;
  height: 270px;
  border: 1px solid #e8e8e8;
  padding: 50px 30px;
  float: left;
}
.main_inner .product_img .img {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}
.product_item_info {
  width: 600px;
  float: right;
}
.product_item_info_title {
  /* font-family: SimHei; */
  font-size: 20px;
  font-weight: bold;
  /* color: #0e05d0; */
  color: green;
  margin-bottom: 20px;
  letter-spacing: 5px;
}
.other {
  margin-bottom: 40px;
}
.pageDiv {
  width: 100%;
  margin-bottom: 40px;
}
.pageDiv div {
  height: 250px;
  border: 1px solid #e8e8e8;
  display: inline-block;
  width: 380px;
  text-align: center;
  color: #565656;
  margin: 20px 20px 0 -2px;
  position: relative;
  padding-bottom: 50px;
}
.pageDiv div:last-child {
  margin-right: 0;
}
.pageDiv div p {
  margin: 30px 0;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pageDiv div img {
  margin-top: 30px;
  /* width: 330px; */
  /* height: 250px; */
  border: none;
  /* object-fit: scale-down; */
  max-width: 70%;
  max-height: 70%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>


// WEBPACK FOOTER //
// src/components/productDetail/productDetail.vue